<script setup lang='ts'>
import type { FooterProps } from '~/utils/footer'
import { ContentDiv, ContentGrid } from '#components'
import { faPaperPlane } from '@fortawesome/pro-light-svg-icons'

const props = defineProps<FooterProps>()

const meta = useFooterMeta(props)

const { data: newsletter, isPending } = useNewsletterCmsData()

const { theme } = useTheme()
</script>

<template>
  <footer :class="footerVariants.base({ theme })">
    <component :is="meta.wide ? ContentGrid : ContentDiv">
      <div :class="meta.wide ? 'full-width' : 'max-w-screen-xl mx-auto'">
        <div class="flex flex-col gap-xl md:hidden">
          <FooterMobile />
        </div>
        <div class="hidden md:grid gap-xl grid-cols-2 md:grid-cols-3 xl:grid-cols-4 grid-rows-2 lg:grid-rows-1 grid-col-flow">
          <div class="flex flex-col gap-m md:gap-l col-span-1">
            <h4 class="title-s">
              Kontakt
            </h4>
            <div class="flex flex-col gap-2xs">
              <a href="mailto:post@juridika.no" class="text-small">post@juridika.no</a>
              <PhoneNumber value="+4724147500" class="text-small" hide-country-code />
              <span class="text-small">Postboks 508 Sentrum</span>
              <span class="text-small">0105 Oslo</span>
            </div>
          </div>
          <div class="flex flex-col gap-m lg:gap-l col-span-1">
            <h4 class="title-s">
              Informasjon
            </h4>
            <div class="flex flex-col gap-2xs">
              <NuxtLink v-for="(item, key) in LAYOUT_FOOTER_LINKS" :key="key" :to="item.url" :aria-label="`Lenke til ${item.label.toLowerCase()}`">
                {{ item.label }}
              </NuxtLink>
            </div>
          </div>
          <div class="flex flex-col gap-m md:gap-l col-span-1">
            <h4 class="title-s">
              En tjeneste fra
            </h4>
            <FooterAuthor />
          </div>
          <div class="flex flex-col gap-l col-span-1 md:col-span-4 xl:col-span-1">
            <ClientOnly>
              <Skeleton v-if="isPending" class="h-10 w-full rounded" />
              <h4 v-else-if="!newsletter?.components?.hubspotFormId" class="font-normal title-s">
                Følg oss
              </h4>
              <Button v-else class="!no-underline !rounded" size="small" variant="primary" :color="theme === 'blurple' ? 'carbon' : theme" :to="{ name: 'newsletter' }" :icon="faPaperPlane" icon-position="right">
                Meld deg på vårt nyhetsbrev
              </Button>

              <template #fallback>
                <Skeleton class="h-10 w-full rounded" />
              </template>
            </ClientOnly>
            <div class="flex justify-start gap-s">
              <SocialLink v-for="provider in SOCIAL_PROVIDERS" :key="provider" :provider="provider" />
            </div>
          </div>
        </div>
      </div>
    </component>
  </footer>
</template>
